import { defineComponent as _defineComponent } from 'vue'
import CardSectionAwardsItem from './CardSectionAwardsItem.vue';
import { AbSlider, AbSliderItem } from '../../../ui';

interface Props {
  awards: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwardsSlider',
  props: {
    awards: null
  },
  emits: ["item-click", "active-index-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'item-click', index: number): void
  (e: 'active-index-change', index: number): void
}), expose: any, slots: any, attrs: any }) {





const onRealIndexChange = (realIndex: number) => {
  emit('active-index-change', realIndex);
};

return { __sfc: true,emit, onRealIndexChange, CardSectionAwardsItem, AbSlider, AbSliderItem }
}

})